import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sipp_warranty_small",
  "use": "icon-sipp_warranty_small-usage",
  "viewBox": "0 0 738.5 738.5",
  "content": "<symbol viewBox=\"0 0 738.5 738.5\" id=\"icon-sipp_warranty_small\">\n  <defs>\n    <style>\n      #icon-sipp_warranty_small .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M369.2,0c46.1,0,83.5,50.6,124.5,68,40.9,17.4,104.9,7.8,136,40.8,31.1,32.9,23.2,93.4,40.8,136s68,78.3,68,124.5-50.6,83.5-68,124.5-7.8,104.9-40.8,136-93.4,23.5-136,40.8-78.3,68-124.5,68-83.5-50.6-124.5-68-104.9-7.8-136-40.8-23.5-93.4-40.8-136S0,415.4,0,369.2s50.6-83.5,68-124.5c17.4-40.9,7.8-104.9,40.8-136,32.9-31.1,93.4-23.5,136-40.8S323.1,0,369.2,0ZM325.1,396.7l-63.4-56.8c-10.4-9.3-26.4-8.4-35.7,2l-23.4,26.2c-9.1,10.2-8.4,25.8,1.5,35.1l107.1,101.5c7.8,7.4,20.1,7.5,28,.2l196-207.1c9.6-10.2,9.1-26.2-1.1-35.8l-29-27.1c-10.3-9.7-26.6-8.9-36,1.6l-144,160.2h0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sipp_warranty_small.svg
// module id = eq4c
// module chunks = 49